// src/components/UiComponents/TagTool.jsx

import React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { EditorUtils } from '@progress/kendo-react-editor';

const TagTool = (props) => {
    const { view } = props;

    const tags = [
        { text: 'First Name', value: '<First Name>' },
        { text: 'Last Name', value: '<Last Name>' },
        { text: 'Company Name', value: '<Company Name>' },
        { text: 'Title', value: '<Title>' },
        { text: 'Salutation', value: '<Salutation>' },
        { text: 'Signature', value: '<Signature>' }
    ];

    const onChange = (event) => {
        
        //console.log(event)
        const tag = event.target.value;
        //console.log(tag.value)
        const tag_value = tag.value;
        
        if (tag) {
            const editor = document.querySelector('.k-editor iframe').contentWindow.document;
            const sel = editor.getSelection();
            let range;
            if (sel.rangeCount > 0) {
                range = sel.getRangeAt(0);
            } 
            else {
                range = editor.createRange();
                const editorBody = editor.body || editor.documentElement;
                range.setStart(editorBody, 0);
                range.setEnd(editorBody, 0);
            }
            const node = editor.createTextNode(tag_value);
            range.deleteContents();
            range.insertNode(node);
            range.setStartAfter(node);
            range.setEndAfter(node);
            sel.removeAllRanges();
            sel.addRange(range);
        }
    };

    return (
        <DropDownList
            style={{width:200}}
            data={tags}
            textField="text"
            dataItemKey="value"
            onChange={onChange}
            defaultItem={{ text: 'Insert Tag', value: '' }}
        />
    );
};

export default TagTool;
